import api from './api';

export const authService = {
  login: async (username, password) => {
    try {
      const response = await api.post('/login', {
        username,
        password,
      });
      
      const { access_token, refresh_token } = response.data.data.token;
      const { user } = response.data.data;
      
      // Store tokens
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      
      // Store user information
      localStorage.setItem('user_name', user.name || '');
      localStorage.setItem('user_email', user.email || '');
      localStorage.setItem('user_phone', user.phone || '');

      // Store IDs used for defaults in admin operations
      localStorage.setItem('user_project_id', user.project_id || '');
      localStorage.setItem('user_client_platform_id', user.client_platform_id || '');
      localStorage.setItem('user_client_type_id', user.client_type_id || '');
      localStorage.setItem('user_role_id', user.role_id || '');
      
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  logout: async () => {
    try {
      await api.delete('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Clear tokens and user data regardless of API response
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user_name');
      localStorage.removeItem('user_email');
      localStorage.removeItem('user_phone');

      localStorage.removeItem('user_project_id');
      localStorage.removeItem('user_client_platform_id');
      localStorage.removeItem('user_client_type_id');
      localStorage.removeItem('user_role_id');
    }
  },

  refresh: async (refreshToken) => {
    try {
      const response = await api.put('/auth/refresh', {
        refresh_token: refreshToken,
      });
      
      const { access_token, refresh_token } = response.data.data;
      
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);
      
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('access_token');
  },

  getAccessToken: () => {
    return localStorage.getItem('access_token');
  },

  getRefreshToken: () => {
    return localStorage.getItem('refresh_token');
  },

  getUserName: () => {
    return localStorage.getItem('user_name');
  },

  getUserEmail: () => {
    return localStorage.getItem('user_email');
  },

  getUserPhone: () => {
    return localStorage.getItem('user_phone');
  },
};
